<template>
  <div>
    <HeaderComponent
      :pageContent="pageHeader"
      @change_language="handleHeaderClick"
    ></HeaderComponent>
    <div class="container mt-4">
      <div class="row" id="cars">
        <div class="col-md-12">
          <h2 class="text-primary" style="color: #0c27bd !important">Classroom Management Tools</h2>
          <hr />
          <p class="text-primary">
            Effectively managing a classroom is key to creating a positive and productive learning environment. Here are some helpful tools teachers can use:
          </p>
        </div>
        
        <div class="row mt-4">
          <div class="col-md-12">
            <div class="d-flex flew-row flex-wrap justify-content-center">
              <div class="col-md-4">
                <a
                  href="https://classdojo.com"
                  target="_blank"
                >
                  <img
                    src="assets/images/classroom-management/GoDojo.png"
                    alt="chase"
                    class="img-fluid d-block mx-auto mb-3"
                    style="height: 180px;border-radius:20px"
                  />
                  <h3 class="text-primary text-center">GoDojo</h3>
                  <p class="text-center text-primary">
                    A popular platform for tracking student behavior and engaging with parents through real-time updates and messages.
                  </p>
                </a>
              </div>

              <div class="col-md-4">
                <a
                  href="https://gonoodle.com"
                  target="_blank"
                >
                  <img
                    src="assets/images/classroom-management/GoNoodles.png"
                    alt="chase"
                    class="img-fluid d-block mx-auto mb-3"
                    style="height: 180px;border-radius:20px"
                  />
                  <h3 class="text-primary text-center">GoNoodle</h3>
                  <p class="text-center text-primary">
                    This tool offers fun brain breaks and movement activities to keep kids energized and focused.
                  </p>
                </a>
              </div>

              <div class="col-md-4">
                <a
                  href="https://bouncyballs.org"
                  target="_blank"
                >
                  <img
                    src="assets/images/classroom-management/BouncyBalls.png"
                    alt="chase"
                    class="img-fluid d-block mx-auto mb-3"
                    style="height: 180px;border-radius:20px"
                  />
                  <h3 class="text-primary text-center">Bouncy Balls</h3>
                  <p class="text-center text-primary">
                    This tool offers fun brain breaks and movement activities to keep kids energized and focused.
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br><br>
      <div class="row">
        <div class="col-md-12">
          <h2 class="text-primary" style="color: #0c27bd !important">
            TED Talks for Teachers
          </h2>
          <hr />
          <p class="text-primary">
            {{ pageContent.intro_paragraph }}
          </p>
        </div>
        <br /><br />
        <div class="container mt-4">
          <div class="row mt-4">
            <div class="col-md-4" v-for="video in videos" :key="video.id">
              <div class="d-flex flex-column h-100">
                <img
                  :src="video.image"
                  class="img-fluid"
                  alt="Video Thumbnail"
                />
                <div class="icon-content mt-2 p-3 flex-grow-1">
                  <h5 class="fs-20 mb-2 text-primary">{{ video.title }}</h5>
                  <p>{{ video.description }}</p>
                </div>
                <div class="mt-auto p-3">
                  <button
                    class="btn btn-primary w-100"
                    @click="openModal(video.url)"
                  >
                    <i class="fa fa-play"></i> &nbsp;{{
                      pageContent.watch_button
                    }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <br />
    <br />

    <br />
    <br />

    <br />
    <br />

    <!-- Modal (using v-if for conditional rendering) -->
    <div
      v-if="showModal"
      class="modal fade show d-block"
      tabindex="-1"
      aria-labelledby="videoModalLabel"
      aria-hidden="true"
      style="background: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ pageContent.modal_title }}</h5>
            <button
              type="button"
              class="btn-close"
              @click="closeModal"
            ></button>
          </div>
          <div class="modal-body">
            <iframe
              v-if="videoUrl"
              :src="videoUrl"
              width="100%"
              height="400"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>
<script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import globalMixins from "@/plugins/globalMixins";

export default {
  name: "Classroom Management",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  data() {
    return {
      showModal: false,
      videoUrl: "",
      pageContent: [],
      pageHeader: [],
      pageFooter: [],
      videos: [
        {
          id: 1,
          title: "Teaching Methods for Inspiring the Students of the Future",
          url: "https://www.youtube.com/embed/UCFg9bcW7Bk?si=l12Dg3ipogZddcJc",
          image: "/assets/images/classroom-management/1.png",
          description:
            "Collaboration, communication, critical thinking, and creativity—essential elements in every classroom.",
        },
        {
          id: 2,
          title: "Becoming a Better Teacher",
          url: "https://www.youtube.com/embed/fdZkmbY0HB0?si=AT1mje-zJHWYgMcE",
          image: "/assets/images/classroom-management/2.png",
          description:
            "In the TEDx talk 'Becoming a Better Teacher,' Mariappan Jawaharlal discusses fostering curiosity and critical thinking.",
        },
        {
          id: 3,
          title: "Cultivating Intrinsic Motivation and Creativity",
          url: "https://www.youtube.com/embed/v2eRnhBvI_I?si=iz2fe-Xt2s1c_OgL",
          image: "/assets/images/classroom-management/3.png",
          description:
            "Beth Hennessey emphasizes the importance of fostering curiosity and self-driven learning in the classroom.",
        },
      ],
    };
  },
  mounted() {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      this.language = storedLanguage;
    }
    this.convertLanguage();
  },
  methods: {
    openModal(url) {
      console.log(url);
      this.videoUrl = url;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.videoUrl = "";
    },
    handleHeaderClick() {
      this.convertLanguage();
    },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }

      let lang = this.language;
      if (lang === "us") {
        lang = "en";
      }

      console.log("Updated content:", lang);

      const converted = globalMixins.class_room[lang];

      const pageHeader = globalMixins.pageHeader[lang];

      const pageFooter = globalMixins.pageFooter[lang];

      if (converted) {
        this.pageContent = {
          ...this.pageContent,
          ...converted,
        };

        this.pageHeader = {
          ...this.pageHeader,
          ...pageHeader,
        };

        this.pageFooter = {
          ...this.pageFooter,
          ...pageFooter,
        };
      }
    },
  },
};
</script>